import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule, RouterOutlet } from '@angular/router';
import { doc, Firestore, setDoc } from '@angular/fire/firestore';
import { Observable, Subscription } from 'rxjs';
import { AdminAuthComponent } from '../../auth/admin-auth-component/admin-auth-component';
import { Tournament } from '../shared/tournament';
import { TournamentCategory } from '../shared/tournament-category';
import { OpenSquashService } from '../shared/services/open-squash-service';

@Component({
  selector: 'app-open13-component',
  imports: [RouterModule, RouterOutlet, CommonModule, MatButtonModule],
  templateUrl: './open13-component.html',
  styleUrl: './open13-component.scss',
})
export class Open13Component {
  private openSquashService = inject(OpenSquashService);
  private dialog = inject(MatDialog);
  private firestore = inject(Firestore);

  // El torneo aún no existe en Firestore: mostramos el botón "Crear Torneo".
  torneoCreado = true;

  tournament!: Tournament;
  categories: TournamentCategory[] = [];
  esAdmin$!: Observable<boolean>;
  tournamentSubscription!: Subscription;

  ngOnInit(): void {
    this.esAdmin$ = this.openSquashService.esAdmin$;
    console.log('1. estableciendo torneo> open13');
    this.openSquashService.setTournament('13open');
    console.log('2. recibiendo info torneo> open13');
    this.tournamentSubscription = this.openSquashService.tournament$.subscribe(
      (tournament) => {
        console.log('1. result query torneo recibido', tournament);
        this.tournament = tournament;
        this.categories = tournament.categories.sort(
          (a, b) => a.categoryOrder - b.categoryOrder
        );
      },error => {
        console.error('Error al cargar el torneo open13:', error);
      }
    );
  }

  authAdmin() {
    this.dialog
      .open(AdminAuthComponent)
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.openSquashService.setAsAdmin(true);
        }
      });
  }

  logout() {
    this.openSquashService.setAsAdmin(false);
  }

  async crearTorneo() {
    const categorias = [
      'primera', 'segunda', 'tercera', 'cuarta',
      'quinta', 'sexta', 'novatos', 'damas',
      'juvenil', 'infantil', 'kids'
    ];

    const tournament = {
      name: 'Decimotercer Open Squash',
      categories: categorias.map((cat, i) => ({
        category: cat,
        categoryOrder: i + 1,
        groups: [{ name: 'A', players: [] }],
        players: [],
        finals: {},
        hasQuarterFinals: false,
        hasSemiFinals: false,
        hasFinal: false,
      })),
    };

    const ref = doc(this.firestore, 'tournament/13open');
    await setDoc(ref, tournament);
    this.torneoCreado = true;
    console.log('Torneo 13open creado en Firestore');
    // Recargar datos del torneo
    this.openSquashService.setTournament('13open');
    this.tournamentSubscription = this.openSquashService.tournament$.subscribe(
      (tournament) => {
        this.tournament = tournament;
        this.categories = tournament.categories.sort(
          (a, b) => a.categoryOrder - b.categoryOrder
        );
      }
    );
  }

  ngOnDestroy(): void {
    this.tournamentSubscription.unsubscribe();
  }
}
